"use client";

// import { Card, CardContent } from "@/components/ui/card";

export const servicesData = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    title: "Website Development",
    description: "Visually stunning, user-friendly, conversion-driven.",
    category: "Development",
  },
   {
    id: 6,
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80",
    title: "Mobile App Development",
    description: "Seamless apps for Android, iOS, and cross-platform.",
    category: "Development",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&q=80",
    title: "Performance Marketing",
    description: "Campaigns that increase visibility and drive targeted results.",
    category: "Marketing",
  },
  
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=800&q=80",
    title: "Social Media Management",
    description: "Building a strong, engaging presence across social platforms.",
    category: "Marketing",
  },
  
  // {
  //   id: 5,
  //   image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
  //   title: "Consultancy Services",
  //   description: "Strategic advice and expert insights for business growth.",
  //   category: "Consulting",
  // },
 
  {
    id: 7,
    image: "https://img.freepik.com/free-vector/ux-ui-typographic-header-app-interface-improvement-user-interface-design-user-experience-development-modern-technology-concept-flat-vector-illustration_613284-1484.jpg?semt=ais_hybrid&w=740&q=80",
    title: "UI/UX Design",
    description: "User-centered design solutions that create intuitive and delightful digital experiences.",
    category: "Design",
  },
  {
    id: 2,
    image: "https://www.intepat.com/wp-content/uploads/2022/12/free-logo-maker-online-and-download.png",
    title: "Branding & Logo Design",
    description: "Crafting unique brand identities that resonate with your audience.",
    category: "Design",
  }
  // {
  //   id: 8,
  //   image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80",
  //   title: "E-commerce Solutions",
  //   description: "Complete online store solutions that drive sales and provide seamless shopping experiences.",
  //   category: "Development",
  // },
  // {
  //   id: 9,
  //   image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80",
  //   title: "Content Strategy",
  //   description: "Strategic content planning and creation that engages audiences and builds brand authority.",
  //   category: "Marketing",
  // }
];

export default function ServicesGrid() {
  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
      <div className="text-center mb-8 sm:mb-12">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
          Our Services
        </h2>
        <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-2">
          Explore our full suite of services designed to elevate your business and build your digital presence.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
        {servicesData.map((card) => (
          <div
            key={card.id}
            className="group relative overflow-hidden rounded-2xl sm:rounded-3xl border-0 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1 sm:hover:-translate-y-2 cursor-pointer"
          >
            <div className="relative h-56 sm:h-72 lg:h-80 overflow-hidden">
              <img
                src={card.image}
                alt={card.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-500" />

              <div className="absolute top-4 left-4 px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full">
                <span className="text-white text-sm font-medium">{card.category}</span>
              </div>

              <div className="absolute inset-0 p-4 sm:p-6 flex flex-col justify-end text-white">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-1 sm:mb-2 group-hover:mb-4 transition-all duration-300 leading-snug">
                    {card.title}
                  </h3>
                  <p className="text-gray-200 text-sm sm:text-base leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200 line-clamp-2">
                    {card.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
